import {
  AfterContentInit,
  AfterViewInit,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { RegelSetActie } from '../models/RegelSetActie';
import { RegelsService } from '../services/regels.service';
import { genericSortingAccessor } from '../shared.module';
import { RegelSetActieDialogComponent } from './dialogs/regel-set-actie-dialog.component';
import { RegelComponent } from './regel.component';

@Component({
  selector: 'app-regel-set-actie',
  templateUrl: './regel-set-actie.component.html',
  styleUrls: ['./beheer-regels.component.scss']
})
export class RegelSetActieComponent implements OnInit {
  public selectedRegelSet: string;

  dataSourceRegelSetActie = new MatTableDataSource<RegelSetActie>();
  displayedColumnsRegelSetActie: string[] = [
    'actieType',
    'preText',
    'waardeActie',
    'action'
  ];
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private regelsSvc: RegelsService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.selectedRegelSet = params.get('regelSetId');
      console.log(this.selectedRegelSet);
    });

    this.refreshDataSourceRegelSetActie();
  }

  refreshDataSourceRegelSetActie(): void {
    this.regelsSvc.loadRegelSetActie(this.selectedRegelSet).subscribe((o) => {
      this.dataSourceRegelSetActie.data = o;
      this.dataSourceRegelSetActie.sort = this.sort;
      this.dataSourceRegelSetActie.sortingDataAccessor = genericSortingAccessor;
    });
  }

  openDialog(action, obj) {
    obj.action = action;
    let dialogRef = this.dialog.open(RegelSetActieDialogComponent, {
      width: '60%',
      data: obj
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.event == 'Toevoegen') {
          this.addRowData(result.data);
        } else if (result.event == 'Bewerken') {
          this.updateRowData(result.data);
        } else if (result.event == 'Verwijderen') {
          this.deleteRowData(result.data);
        }
      }
    });
  }

  addRowData(row_obj: RegelSetActie) {
    console.log('Add');
    console.log(row_obj);
    const i: RegelSetActie = {
      regelSetId: +this.selectedRegelSet,
      regelSetActieId: 0,
      actieType: row_obj.actieType,
      preText: row_obj.preText,
      waardeActie: row_obj.waardeActie
    };

    this.regelsSvc.saveRegelSetActie(i).subscribe(
      (r) => {
        const changeData = this.dataSourceRegelSetActie.data;
        this.dataSourceRegelSetActie.data = changeData.concat(r);
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }
  updateRowData(row_obj: RegelSetActie) {
    console.log('edit');
    console.log(row_obj);

    const i: RegelSetActie = {
      regelSetId: +this.selectedRegelSet,
      regelSetActieId: row_obj.regelSetActieId,
      actieType: row_obj.actieType,
      preText: row_obj.preText,
      waardeActie: row_obj.waardeActie
    };

    this.regelsSvc.saveRegelSetActie(i).subscribe(
      (r) => {
        const changeData = this.dataSourceRegelSetActie.data;
        const foundIndex = changeData.findIndex(
          (x) => x.regelSetActieId === r.regelSetActieId
        );
        changeData[foundIndex] = r;
        this.dataSourceRegelSetActie.data = changeData;
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }
  deleteRowData(row_obj: RegelSetActie) {
    console.log('delete ');
    console.log(row_obj);

    const i: RegelSetActie = {
      regelSetId: +this.selectedRegelSet,
      regelSetActieId: row_obj.regelSetActieId,
      actieType: row_obj.actieType,
      preText: row_obj.preText,
      waardeActie: row_obj.waardeActie
    };

    this.regelsSvc.deleteRegelSetActie(i.regelSetActieId).subscribe(
      (r) => {
        this.refreshDataSourceRegelSetActie();
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }

  showErrorToast(error: any, melding: string) {
    let tekst = melding;

    if (error.message) {
      tekst += '(' + error.message + ')';
    }

    this.snackBar.open(tekst, null, { duration: 3000 });
  }
}
